import { load } from '@fingerprintjs/fingerprintjs'
import md5 from 'md5'

/**
 * 常用的方法
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
export function getBrowser(): {
  Sys: { name: string; ver: string }
  info: string
} {
  const Sys = { name: '', ver: '' }
  const ua = navigator.userAgent.toLowerCase()
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/
  const m = ua.match(re)
  if (!m) {
    return {
      Sys: {
        name: '',
        ver: ''
      },
      info: ''
    }
  }
  Sys.name = m[1].replace(/version/, 'safari')
  Sys.ver = m[2]
  return { Sys, info: ua }
}
export function checkOS() {
  const sUserAgent = navigator.userAgent.toLowerCase()
  const sPlatform = navigator.platform.toLowerCase()
  const isWin = sPlatform === 'win32' || sPlatform === 'windows'
  const isMac = sPlatform === 'mac68k' || sPlatform === 'macppc' || sPlatform === 'macintosh' || sPlatform === 'macintel'
  const isUnix = sPlatform === 'x11' && !isWin && !isMac
  const isLinux = String(sPlatform).indexOf('linux') > -1
  if (isMac) return 'MAC'
  if (isUnix) return 'Unix'
  if (isLinux) return 'Linux'
  if (isWin) return 'Windows'
  if (isWin) {
    const isWin2K = sUserAgent.indexOf('windows nt 5.0') > -1 || sUserAgent.indexOf('windows 2000') > -1
    if (isWin2K) return 'Win2000'
    const isWinXP = sUserAgent.indexOf('windows nt 5.1') > -1 || sUserAgent.indexOf('windows xp') > -1
    if (isWinXP) return 'WinXP'
    const isWin2003 = sUserAgent.indexOf('windows nt 5.2') > -1 || sUserAgent.indexOf('windows 2003') > -1
    if (isWin2003) return 'Win2003'
    const isWinVista = sUserAgent.indexOf('windows nt 6.0') > -1 || sUserAgent.indexOf('windows vista') > -1
    if (isWinVista) return 'WinVista'
    const isWin7 = sUserAgent.indexOf('windows nt 6.1') > -1 || sUserAgent.indexOf('windows 7') > -1
    if (isWin7) return 'Win7'
    const isWin8 = sUserAgent.indexOf('windows nt 6.2') > -1 || sUserAgent.indexOf('windows nt 6.3') > -1 || sUserAgent.indexOf('windows 8') > -1
    if (isWin8) return 'Win8'
    const isWin10 = sUserAgent.indexOf('windows nt 10') > -1 || sUserAgent.indexOf('windows 10') > -1
    if (isWin10) return 'Win10'
  }
  return 'other'
}
export function parse(objString: any) {
  let resultObj = null // 目标对象
  try {
    resultObj = new Function(`return ${objString}`)()
  } catch (e) {
    resultObj = null
  }
  return resultObj
}
export function getUserId() {
  const userId = localStorage.getItem('userid')
  if (userId) {
    return userId
  } else {
    // fuck
    // const temp: any = (Date.parse(new Date().toISOString()) % 100000000) / 1000;
    // const userIdTemp = `${Number.parseInt(temp)}`;
    // localStorage.setItem('userId', userIdTemp);
    // return userIdTemp;
    return undefined
  }
}

export function getMacOsVersion() {
  return navigator.userAgent.substr(navigator.userAgent.indexOf('OS X') + 5, navigator.userAgent.substr(navigator.userAgent.indexOf('OS X') + 5).indexOf(')'))
}

export const _base64ToArrayBuffer = (base64: string) => {
  return new Uint8Array(
    window
      .atob(base64)
      .split('')
      .map((v) => v.charCodeAt(0))
  )
}

export const _arrayBufferToBase64 = (buffer: Uint8Array) => {
  const bytes = new Uint8Array(buffer)
  return window.btoa(
    bytes.reduce((prev, _cur, i) => {
      return prev + String.fromCharCode(bytes[i])
    }, '')
  )
}

export const networkText = (level: number) => {
  let result = ''
  switch (level) {
    case 1:
      result = '极好'
      break
    case 2:
      result = '较好'
      break
    case 3:
      result = '一般'
      break
    case 4:
      result = '差'
      break
    case 5:
    case 6:
      result = '极差'
      break
    case 0:
      result = '未知'
      break
  }
  return result
}

// 获取参数
export function getParams(query: string): { [key: string]: string } {
  return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce((params: { [key: string]: string }, param: string) => {
    const [key, value] = param.split('=')
    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
    return params
  }, {})
}

export const checkIsLoadScript = (src: string) => {
  const scriptObjs = document.getElementsByTagName('script')
  const reg = RegExp(src)
  for (const sObj of scriptObjs) {
    if (sObj.src.match(reg)) {
      return true
    }
  }
  return false
}

export const getVisitorId = async () => {
  if (!localStorage.visitorId) {
    const agentPromise = load()
    const agent = await agentPromise
    const result = await agent.get()
    const { visitorId } = result
    localStorage.visitorId = visitorId
    console.log(`%cvisitorId: %c${visitorId}`, 'color: blue', 'color: #ff009d')
  } else {
    console.log(`%cvisitorId: %c${localStorage.visitorId}`, 'color: blue', 'color: #ff009d')
  }
}

// 是否为谷歌急速浏览器
export function isGoogleJisuBrowser() {
  return typeof tsbrowser === 'object'
}

/**
 * 获取当前操作系统
 */
export const getOS = () => {
  const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
  return isMac ? 'mac' : 'win'
}

export function isSupportBrowser() {
  /**
   * 支持的浏览器：
   * 1)谷歌浏览器 >= 58
   * 2)qq浏览器 >= 9.5.1, 使用chrome内核
   * 3)360极速浏览器 >= 9.5.0.124, 使用chrome内核
   */
  const supporttBrowserList = [
    {
      name: `chrome`,
      ver: 58
    }
  ]
  let ret = false
  const checkBrowser = getBrowser()
  const browser = checkBrowser.Sys
  const info = checkBrowser.info

  if (browser) {
    let { name, ver } = browser
    ver = parseInt(ver)
    for (const i in supporttBrowserList) {
      if (supporttBrowserList[i].name === name && ver >= supporttBrowserList[i].ver) {
        ret = true
      }
    }
    // 增加对谷歌急速浏览器的判断
    if (isGoogleJisuBrowser()) {
      ret = false
    }
    // 是否是Edge浏览器
    if (navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
      ret = false
    }
    // 是否是搜狗浏览器
    const userAgent = navigator.userAgent.toLowerCase()
    const res = userAgent.match(/se 2.x metasr 1.0/i)
    if (res && res.length && res[0] === 'se 2.x metasr 1.0') {
      ret = false
    }
  }
  return { ret, info: info, checkResult: browser }
}

// 检测是否兼容操作系统
export function compatible() {
  const os = checkOS()
  const pass = ['MAC', 'Win7', 'Win8', 'Win10']
  const fail = ['other', 'Unix', 'Linux', 'Win2000', 'WinXP', 'Win2003', 'WinVista']
  if (pass.includes(os)) return true
  if (fail.includes(os)) {
    return false
  }
  return false
}

/**
 * 获取设备信息
 */
export const getMediaDevices = () => {
  const mediaDevices = {
    audioinput: [],
    videoinput: [],
    audiooutput: []
  }
  return window.navigator.mediaDevices.enumerateDevices().then((res) => {
    res.forEach(({ deviceId, kind }) => {
      mediaDevices[kind].push(deviceId)
    })
    return mediaDevices
  })
}

export const validateMediaDevice = (deviceInfo) => {
  return getMediaDevices()
}

// 重新排序
export const reorder = <T>(list: T[], startIndex: number, endIndex: number): T[] => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

export const getUrlParam = (name: string, url?: string) => {
  const u = url || window.location.href,
    reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'),
    r = u.substring(u.indexOf('?') + 1).match(reg)
  return r != null ? decodeURI(r[2]) : ''
}

export const browserType = () => {
  // 权重：系统 + 系统版本 > 平台 > 内核 + 载体 + 内核版本 + 载体版本 > 外壳 + 外壳版本
  const ua = navigator.userAgent.toLowerCase()
  const testUa = (regexp: any) => regexp.test(ua)
  const testVs = (regexp: any) => (ua.match(regexp) + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.')
  // 系统
  let system = 'unknown'
  if (testUa(/windows|win32|win64|wow32|wow64/gi)) {
    system = 'windows' // window系统
  } else if (testUa(/macintosh|macintel/gi)) {
    system = 'mac' // mac系统
  } else if (testUa(/x11/gi)) {
    system = 'linux' // linux系统
  } else if (testUa(/android|adr/gi)) {
    system = 'android' // android系统
  } else if (testUa(/ios|iphone|ipad|ipod|iwatch/gi)) {
    system = 'ios' // ios系统
  }
  // 系统版本
  let systemVs = 'unknown'
  if (system === 'windows') {
    if (testUa(/windows nt 5.0|windows 2000/gi)) {
      systemVs = '2000'
    } else if (testUa(/windows nt 5.1|windows xp/gi)) {
      systemVs = 'xp'
    } else if (testUa(/windows nt 5.2|windows 2003/gi)) {
      systemVs = '2003'
    } else if (testUa(/windows nt 6.0|windows vista/gi)) {
      systemVs = 'vista'
    } else if (testUa(/windows nt 6.1|windows 7/gi)) {
      systemVs = '7'
    } else if (testUa(/windows nt 6.2|windows 8/gi)) {
      systemVs = '8'
    } else if (testUa(/windows nt 6.3|windows 8.1/gi)) {
      systemVs = '8.1'
    } else if (testUa(/windows nt 10.0|windows 10/gi)) {
      systemVs = '10'
    }
  } else if (system === 'mac') {
    systemVs = testVs(/os x [\d._]+/gi)
  } else if (system === 'android') {
    systemVs = testVs(/android [\d._]+/gi)
  } else if (system === 'ios') {
    systemVs = testVs(/os [\d._]+/gi)
  }

  // 内核和载体
  let engine = 'unknow'
  let supporter = 'unknow'
  if (testUa(/applewebkit/gi) && testUa(/safari/gi)) {
    engine = 'webkit' // webkit内核
    if (testUa(/edge/gi)) {
      supporter = 'edge' // edge浏览器
    } else if (testUa(/opr/gi)) {
      supporter = 'opera' // opera浏览器
    } else if (testUa(/chrome/gi)) {
      supporter = 'chrome' // chrome浏览器
    } else {
      supporter = 'safari' // safari浏览器
    }
  } else if (testUa(/gecko/gi) && testUa(/firefox/gi)) {
    engine = 'gecko' // gecko内核
    supporter = 'firefox' // firefox浏览器
  } else if (testUa(/presto/gi)) {
    engine = 'presto' // presto内核
    supporter = 'opera' // opera浏览器
  } else if (testUa(/trident|compatible|msie/gi)) {
    engine = 'trident' // trident内核
    supporter = 'iexplore' // iexplore浏览器
  }

  // 载体版本
  let supporterVs = 'unknow'
  if (supporter === 'chrome') {
    supporterVs = testVs(/chrome\/[\d.]+/gi)
  } else if (supporter === 'safari') {
    supporterVs = testVs(/version\/[\d.]+/gi)
  } else if (supporter === 'firefox') {
    supporterVs = testVs(/firefox\/[\d.]+/gi)
  } else if (supporter === 'opera') {
    supporterVs = testVs(/opr\/[\d.]+/gi)
  } else if (supporter === 'iexplore') {
    supporterVs = testVs(/(msie [\d.]+)|(rv:[\d.]+)/gi)
  } else if (supporter === 'edge') {
    supporterVs = testVs(/edge\/[\d.]+/gi)
  }
  // 外壳和外壳版本
  let shell = 'none'
  let shellVs = 'unknow'
  if (testUa(/micromessenger/gi)) {
    shell = 'wechat' // 微信浏览器
    shellVs = testVs(/micromessenger\/[\d.]+/gi)
  } else if (testUa(/qqbrowser/gi)) {
    shell = 'qq' // QQ浏览器
    shellVs = testVs(/qqbrowser\/[\d.]+/gi)
  } else if (testUa(/ubrowser/gi)) {
    shell = 'uc' // UC浏览器
    shellVs = testVs(/ubrowser\/[\d.]+/gi)
  } else if (testUa(/2345explorer/gi)) {
    shell = '2345' // 2345浏览器
    shellVs = testVs(/2345explorer\/[\d.]+/gi)
  } else if (testUa(/metasr/gi)) {
    shell = 'sougou' // 搜狗浏览器
  } else if (testUa(/lbbrowser/gi)) {
    shell = 'liebao' // 猎豹浏览器
  } else if (testUa(/maxthon/gi)) {
    shell = 'maxthon' // 遨游浏览器
    shellVs = testVs(/maxthon\/[\d.]+/gi)
  } else if (testUa(/bidubrowser/gi)) {
    shell = 'baidu' // 百度浏览器
    shellVs = testVs(/bidubrowser [\d.]+/gi)
  }
  return Object.assign(
    {
      engine, // webkit gecko presto trident
      supporter, // chrome safari firefox opera iexplore edge
      supporterVs,
      system, // windows mac linux android ios
      systemVs
    },
    shell === 'none'
      ? {}
      : {
          shell, // wechat qq uc 2345 sougou liebao maxthon baidu
          shellVs
        }
  )
}

export function sleep(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

// 获取验证码的sign
export const getSliderSign = ({ areaCode = '+86', mobile }: { areaCode: string; mobile: string }) => {
  const timestamp = new Date().getTime()
  const signC = 'er$N@i&2Kc^m9d$'
  const str = `timestamp-${timestamp}-area-${areaCode}-mobile-${mobile}-${signC}`
  return { signL: md5(md5(str) + `-${signC}`), timestamp }
}

interface LineState {
  state: number
  [key: string]: any
}

interface LineObject {
  line: LineState[]
}

interface LinesItem {
  windowId?: string | number
  Lines: LineObject[]
  [key: string]: any
}

/**
 * 合并Lines中的不完整line
 * 完整的line包含state 1, 2, 3
 * 不完整的line会被合并到一起
 *
 * @param {Array} lines - 包含windowId和Lines的数组
 * @returns {Array} 处理后的lines数组
 */
export const mergeIncompleteLines = (lines: LinesItem[]): LinesItem[] => {
  return lines.map((item: LinesItem) => {
    const newLines: LineObject[] = []
    let incompleteBuffer: LineState[][] = []

    item.Lines.forEach((lineObj: LineObject) => {
      // 检查line是否完整（包含state 1, 2, 3）
      const states = lineObj.line.map((s: LineState) => s.state)
      const hasState1 = states.includes(1)
      const hasState2 = states.includes(2)
      const hasState3 = states.includes(3)
      const isComplete = hasState1 && hasState2 && hasState3

      if (isComplete) {
        // 如果当前line完整，先处理缓存的不完整line
        if (incompleteBuffer.length > 0) {
          newLines.push({
            line: incompleteBuffer.flat()
          })
          incompleteBuffer = []
        }
        // 添加完整的line
        newLines.push(lineObj)
      } else {
        // 如果不完整，添加到缓存
        incompleteBuffer.push(lineObj.line)
      }
    })

    // 处理剩余的不完整line
    if (incompleteBuffer.length > 0) {
      newLines.push({
        line: incompleteBuffer.flat()
      })
    }

    return {
      ...item,
      Lines: newLines
    }
  })
}
